export const colors = {
    black: '#0B0C0F',
    white: '#fff',
    blue50: '#EFF6FF',
    blue100: '#DBEAFE',
    blue200: '#BFDBFE',
    blue300: '#93C5FD',
    blue500: '#3B82F6',
    blue600: '#2563EB',
    blue700: '#1D4ED8',
    blue800: '#1E40AF',
    blue900: '#1E3A8A',
    purpleFaded: '#e6eaf5',
    purple600: '#9333EA',

    pink800: '#6D093C',

    red50: '#FEF2F2',
    red100: '#F9DCDC',
    red200: '#FECACA',
    red500: '#E24B4B',
    red600: '#DC2626',
    red700: '#B91C1C',

    green500: '#29E66B',

    grayDark: '#7B88A8',
    grayLight: '#E6EAF5',
    successGreen: '#08A045',
    emerald50: '#ECFDF5',
    emerald700: '#047857',
    sky50: '#F0F9FF',
    sky700: '#0369A1',
    yellow50: '#FEFCE8',
    yellow500: '#F6C504',
    yellow700: '#A16207',

    indigo300: '#A5B4FC',
    indigo400: '#818CF8',

    gray50: '#F0F2F4',
    gray100: '#DEE2E8',
    gray200: '#C1C8D2',
    gray300: '#A0ABBB',
    gray400: '#8291A5',
    gray500: '#64748B',
    gray600: '#515E71',
    gray700: '#3C4553',
    gray800: '#292F38',
    gray900: '#13161B',
    gray950: '#0B0C0F',

    transparent: 'transparent',

    greyscaleSurfaceDisabled: '#F0F2F4',
    greyscaleBorderDisabled: '#A0ABBB',
    greyscaleTextDisabled: '#A0ABBB',

    surfaceLighter: '#DBEAFE',
    borderDefault: '#1E3A8A',
};

export type Colors = keyof typeof colors;
